// Stripe payment — calls the backend, which creates a Stripe Checkout Session
// (the secret key lives only on the server). The frontend then redirects the
// customer to the returned Stripe-hosted payment URL. Stripe's webhook confirms
// payment and updates the order server-side.

const API_BASE = process.env.REACT_APP_API_BASE || "/api";

export async function createPaymentRequest(orderData) {
  try {
    const res = await fetch(`${API_BASE}/create-payment`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(orderData),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) {
      return { success: false, error: data.error || "Payment could not be started." };
    }
    return {
      success: true,
      paymentUrl: data.paymentUrl,
      sessionId: data.sessionId,
      orderId: data.orderId,
    };
  } catch (e) {
    return { success: false, error: e.message || "Network error" };
  }
}
